export default "__VITE_ASSET__o0Q4oZTg__"